import gql from 'graphql-tag';

import { printPartnerOrderServiceDetails } from '../../../../graphql/fragments/print-partner';

const getPrintPartners = gql`
  query getPrintPartners($id: RecordID, $name: String) {
    printPartners(print_partner_id: $id, name: $name) {
      total
      records {
        id
        name
        print_products {
          total
        }
        order_services {
          total
          records {
            ...printPartnerOrderServiceDetails
          }
        }
      }
    }
  }
  ${printPartnerOrderServiceDetails}
`;

export default getPrintPartners;
